import * as React from 'react';

import { Actions } from './actions';
import { PaymentContextState } from './types';

export type Context = {
    state: PaymentContextState;
    dispatch: React.Dispatch<Actions>;
};

export const defaultState: PaymentContextState = {
    hasInvalidCode: false,
    isBillingAddressSet: false,
    hasBillingAddressError: false,
    transactionUrl: ''
};

export const store = React.createContext<Context>({
    state: defaultState,
    dispatch: () => null
});